import templateUrl from './content-template.html';

export const contentTemplateComponent = {
	bindings:{
		details: '<',
		slugUrl: '@',
		disableButtons:'<',
		isOverviewExist: '@',
		pageName:'@',
		onCancel: '&', 
		onSubmit: '&'
	},

	templateUrl,
	controller: class ContentTemplateComponent {
		constructor($parse, CompareObjectService, ModalService, ContentService, toastr) {
			'ngInject';

			this.$parse = $parse;
			this.compareObjectService = CompareObjectService;
			this.modalService = ModalService;
			this.contentService = ContentService;
			this.toastr = toastr;
		}

		$onInit() {
			this._isOverviewExist = this.$parse(this.isOverviewExist || 'true')(true);
			this.editOverviewFormShow = false;
			this.disableOverviewButtons = false;
			
			if(this._isOverviewExist) {
				this.details.menuOverviewDetails.pageTitle = "Edit Overview";
				this.menuName = this.details.menuOverviewDetails.name;
				this.savedOverviewData = angular.copy(this.details.menuOverviewDetails);
			}
		}
	}
};


// WEBPACK FOOTER //
// ./src/app/common/components/content-template/content-template.component.js